import React from 'react'
import navbar from './Navbar'
import Footer from './Footer'
import { motion } from "framer-motion";
import Background from "./Background";


const Skills = () => {
  return (
    <div className='area relative z-0 bg-black w-full h-full"'>
        <ul class = 'circles'>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </ul>


    <Footer/>  
    </div>
  );
};

export default Skills
